/* istanbul ignore file */
// TODO: Create test file

import { ref, computed, inject } from 'vue';
import { useDebounceFn } from '@vueuse/core';

import { fireLinkTag } from '../../utils/tagManager';
import { TAG_DATA_KEYS } from '../../constants/SalesFloor';

export default function useAnalytics({ spaced = false, isBrandData }) {
  const entryPoint = inject('entryPoint');

  const wordSeparator = spaced ? ' ' : '_';
  const joinText = (strArr) => strArr.join(wordSeparator);

  // @returns 'event_name' || 'link_name'
  const tagDataKeyName = ref(TAG_DATA_KEYS?.[entryPoint.value] || []);

  // @returns 'cws_floating_brand' || 'cws_floating_expand' || 'cws floating brand' || 'cws floating expand'
  const widgetTypeTag = computed(() => joinText([
    'cws',
    'floating',
    isBrandData.value ? 'brand' : 'contextual',
  ]));

  const tagData = computed(() => ({
    default: { [tagDataKeyName.value]: widgetTypeTag.value },
    // @returns '[WIDGET_TYPE_TAG]_collapse' || '[WIDGET_TYPE_TAG] collapse'
    disable: { [tagDataKeyName.value]: `${widgetTypeTag.value }${wordSeparator}collapse` },
    // @returns '[WIDGET_TYPE_TAG]_expand' || '[WIDGET_TYPE_TAG] expand'
    enable: { [tagDataKeyName.value]: `${widgetTypeTag.value }${wordSeparator}expand` },
  }));

  return {
    fireDisableWidgetTag: () => fireLinkTag(tagData.value.disable),
    fireEnableWidgetTag: () => fireLinkTag(tagData.value.enable),
    // debounce makes this feature spam proof
    fireOpenPortalWidgetTag: useDebounceFn(() => fireLinkTag(tagData.value.default), 1000),
  };
}
